module.exports = __webpack_public_path__ + "img/max9.d5f2b4f9.jpg";